/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { IRelatorioVale } from '../../../shared/services/api/rh/vales/ValeService';

async function RelatorioVale(dados: IRelatorioVale, tipo: string) {
  const { emprestimo, recebidos, receber } = dados;
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  const rows = emprestimo.map((row) => {
    return [
      { text: row.nome, style: row.status ? 'urgentText' : undefined, alignment: 'left', fontSize: 8 },
      { text: row.cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'), style: row.status ? 'urgentText' : undefined, alignment: 'left', fontSize: 8 },
      { text: row.periodo, style: row.status ? 'urgentText' : undefined, alignment: 'left', fontSize: 8 },
      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.valor), style: row.status ? 'urgentText' : undefined, alignment: 'right', fontSize: 8 },
    ];
  });
  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0); 
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }
  const imageUrl = process.env.REACT_APP_URL_IMGLOG || '';
  const imageData = await getBase64ImageFromUrl(imageUrl);
  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [10, 30, 30, 10],
    header: '',
    content: ([
      {
        table: {
          body: [
            [
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],
                table: {
                  widths: [500],
                  body: [
                    [
                      { text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16, margin: [0, 5, 0, 0], bold: true, color: '#FFFFFF', alignment: 'center', fillColor: '#00A47B', border: [false, false, false, false] },
                    ],
                    [
                      { text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true] },
                    ],
                  ]
                }
              },
            ],
            [
              { text: 'Relatório de Adiantamento de Colaborador', colSpan: 2, margin: [5, 10, 0, 0], fontSize: 18, bold: true, alignment: 'center', border: [false, false, false, false] },
              {}
            ]
          ]
        }
      },
      {text: 'Tipo de Desconto: '+tipo, fontSize: 14},
      {
        table: {
          widths: [320, 60, 60, 60], 
          headerRows: 1, 
          body: [
            [
              { text: 'Nome', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 10 },
              { text: 'CPF', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 10 },
              { text: 'Período', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 10 },
              { text: 'Valor Parcela', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 10 },
            ],
            ...rows,
            [
              {text: '', border: [false, false, false, false]},
              {text: 'Total Descontado:', alignment: 'right', colSpan: 2, border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(recebidos.recebido), alignment: 'right',  fontSize: 10, bold: true, border: [false, false, false, false]},

            ],
            [
              {text: '', border: [false, false, false, false]},
              {text: 'Total a Descontar:', alignment: 'right', colSpan: 2, border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
              {text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(receber.receber), alignment: 'right',  fontSize: 10, bold: true, border: [false, false, false, false]},
            ]
          ]
        },
      },
    ]),
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        color: '#2E7D32',
        alignment: 'left'
      },
      infoLabel: {
        fontSize: 12,
        bold: true,
        color: '#555555'
      },
      infoValue: {
        fontSize: 12,
        color: '#333333'
      },
      tableHeader: {
        bold: true,
        fontSize: 10,
        fillColor: '#f5f5f5',
        alignment: 'center'
      },
      urgentIcon: {
        bold: true,
        fontSize: 12,
        color: '#FF0000'
      },
      urgentText: {
        bold: true,
        color: '#0a6e29'
      },
      obsLabel: {
        bold: true,
        fontSize: 11
      },
      obsValue: {
        fontSize: 11
      }
    },
    defaultStyle: {
      fontSize: 10,
      margin: [0, 1, 0, 1]
    }
  };
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.open();
}
export default RelatorioVale;

